import { useEffect, useState } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { Group, LoadingOverlay, Stack, Text } from "@mantine/core";
import BackButton from "../../../../../components/View/BackButton";
import { getZapierHooks } from "../../../../../api/ZapierApi";
import ZapierItem from "./ZapierItem";
import CreateZapier from "./CreateZapier";
import { useSessionStore } from "../../../../../stores/UserStore";
import { getEmbedUrl } from "../../../../../functions/utilFunctions";

const ZapierContent = ({ handleClose, type }) => {
  const lang = useLanguage((s) => s.language);
  const reseller = useSessionStore((s) => s.reseller);
  const hasVideo = reseller?.videos?.find(
    (x) => x.name === "LeadsTrackingZapierMakeSyncTutorial"
  );
  const video1 = reseller?.videos?.find(
    (x) => x.name === "LeadsTrackingZapierMakeSyncTutorial"
  )?.url;

  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  const updateItem = (id, newProfile) => {
    setItems((prev) => prev.map((x) => (x.id === id ? newProfile : x)));
  };

  useEffect(() => {
    if (loading) {
      getZapierHooks()
        .then((response) => {
          setItems(
            response.data.zapier_hooks_list
              .sort((a, b) => b.id - a.id)
              .filter((x) => x.source === type)
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [loading]);

  return (
    <>
      <Group gap={"xl"} h={"100%"} align="start" wrap="nowrap">
        <Stack pos={"relative"} gap={"xs"} h={"100%"} flex={1}>
          <LoadingOverlay visible={loading} />

          <Text c={"dimmed"}>
            {lang.sync_zapier[type === "prm" ? "main_text" : "main_text_stats"]}
          </Text>

          {items.length > 0 ? (
            <Stack gap={"lg"} h={"58vh"} style={{ overflow: "auto" }}>
              {items.map((item, index) => {
                return (
                  <ZapierItem
                    key={item.id}
                    item={item}
                    type={type}
                    handleReload={() => setLoading(true)}
                    updateItem={updateItem}
                  />
                );
              })}
            </Stack>
          ) : (
            <Text c={"dimmed"} size="lg" ta={"center"} mt={64}>
              {lang.sync_zapier.no_elements}
            </Text>
          )}
        </Stack>
        {(reseller?.name === "Magileads" || hasVideo) && !loading && (
          <Stack ml={"auto"} mt={32}>
            {video1 ? (
              video1.includes("youtube") ? (
                <iframe
                  src={getEmbedUrl(video1)}
                  width="440"
                  height="300"
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                  frameBorder={0}
                  style={{
                    borderRadius: 8,
                  }}
                ></iframe>
              ) : (
                <video
                  src={video1}
                  className="reseller-video"
                  controls
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "block",
                  }}
                />
              )
            ) : (
              <iframe
                src="https://www.youtube.com/embed/rHP3vhX160U?si=fz1yzSd_7s85KwZa"
                title="YouTube video player"
                allowFullScreen=""
                width="600"
                height="380"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                style={{
                  borderRadius: 12,
                  overflow: "hidden",
                  border: "1px solid #00000033",
                }}
              />
            )}
          </Stack>
        )}
      </Group>

      <Group justify="end" mt={"lg"}>
        <BackButton onClick={handleClose} size="md" />
        <CreateZapier
          handleDone={() => setLoading(true)}
          type={type}
          size="md"
        />
      </Group>
    </>
  );
};

export default ZapierContent;
